<template>
	<div class="organiza">
		<vs-row>
			<vs-col vs-type="flex" vs-justify="center" vs-align="start" vs-w="3">
				<div class="custom-tree-container">
					<div class="block">
						<h4 class="p-4">人员组织架构</h4>
						<el-tree
							@node-click="handleNodeClick"
							@node-contextmenu="editNodeClick"
							:props="{label:'name',children:'children'}"
							:data="data"
							node-key="id"
							:default-expanded-keys="['1']"
							:expand-on-click-node="false"
							:render-content="renderContent">
						</el-tree>
					</div>
				</div>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9" style="flex-direction: column;">
				<vs-table ref="table" :max-items="10" :data="users">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
						<div class="flex flex-wrap-reverse items-center">
							<div class="p-3 mb-4 mr-4 rounded-lg search-page__search-bar flex items-center">
								<vs-input placeholder="请输入姓名" v-model="member.name"
								          class="w-full input-rounded-full no-icon-border" icon="icon-search"
								          icon-pack="feather"/>
							</div>
							<div class="p-3 mb-4 mr-4 rounded-lg search-page__search-bar flex items-center">
								<vs-input placeholder="请输入手机号" v-model="member.phone"
								          class="w-full input-rounded-full no-icon-border" icon="icon-search"
								          icon-pack="feather"/>
							</div>
							<div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between">
								<vs-button color="primary" type="filled" @click="getmemberlist" class="mr-4">搜索
								</vs-button>
								<vs-button color="primary" type="filled" @click="jobdiaglo=true" class="mr-4">职位管理
								</vs-button>
								<vs-button color="primary" type="filled" @click="userinfo">新增用户</vs-button>
							</div>
						</div>
					</div>
					<template slot="thead">
						<vs-th>ID</vs-th>
						<vs-th>姓名</vs-th>
						<vs-th>员工编号</vs-th>
						<vs-th>性别</vs-th>
						<vs-th>手机号</vs-th>
						<vs-th>邮箱</vs-th>
						<vs-th>所属单位</vs-th>
						<vs-th>职位名称</vs-th>
						<vs-th>操作</vs-th>
					</template>
					<template slot-scope="{data}">
						<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>
								<p class="product-name font-medium">{{ tr.id }}</p>
							</vs-td>
							<vs-td>
								<p class="product-category">{{ tr.name }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.erpNo ? tr.erpNo : '------' }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.sex == 1 ? '男' : tr.sex == 2 ? '女' : '未知' }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.phone }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.email }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.deptName }}</p>
							</vs-td>
							<vs-td>
								<p class="product-price">{{ tr.positionName ? tr.positionName : '------' }}</p>
							</vs-td>
							<vs-td>
								<el-button type="text" @click="edit(tr)">分配</el-button>
								<el-button type="text" @click="userinfo(tr)">编辑</el-button>
								<el-popconfirm title="确定删除该用户吗？" @confirm="del(tr)">
									<el-button slot="reference" type="text" style="margin-left: 10px;">删除</el-button>
								</el-popconfirm>
							</vs-td>
						</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<vs-pagination class="mt-4" :total="total" v-model="member.pageNum"></vs-pagination>
			</vs-col>
		</vs-row>
		<!-- 弹窗 -->
		<div class="demo-alignment">
			<el-dialog title="信息配置" :visible.sync="diaglo" width="50%" :close-on-click-modal="false">
				<el-form label-width="120px">
					<el-form-item label="所属部门:" style="80%">
						<el-cascader v-model="deptid" :options="deptconfig" :props='props'
						             style="width:360px"></el-cascader>
					</el-form-item>
					<el-form-item label="使用标准:">
						<el-select v-model="standardid" placeholder="请选择" style="360px">
							<el-option :label="s.name" :value="s.id" v-for="(s,i) in standardconfig"
							           :key="i"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="职位名称:">
						<el-select v-model="positionName" placeholder="请选择" style="360px">
							<el-option :label="j.name" :value="j.id" v-for="(j,i) in joblist" :key="i"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="包含自评分:">
						<el-radio v-model="include" label="1">包含</el-radio>
						<el-radio v-model="include" label="2">不包含</el-radio>
						<el-tooltip class="item" effect="dark"
						            content="提示:包含则代表计算平均分时包含自评分,反之则不包含.默认包含自评分"
						            placement="top-start"
						            style="font-size: 18px;height: 20px;vertical-align: text-top;margin-left: 2px;">
							<i class="el-icon-warning-outline"></i>
						</el-tooltip>
					</el-form-item>
					<Auditor :innerVisible="innerVisible" v-if="diaglo" @closediaglo="closediaglo()"
					         @submitmember="submitmember"></Auditor>
					<el-form-item label="审核人员:">
						<draggable draggable=".el-tag" v-model="examiner">
							<el-tag v-for="(tag,index) in examiner" :key="tag.reviewerId" @close="handleClose(index)"
							        closable class="mr-2">{{ tag.reviewerNames }}
							</el-tag>
						</draggable>
						<el-button type="text" class="ml-4" @click="goauditor">去修改</el-button>
					</el-form-item>
					<el-form-item label="是否管理层:">
						<el-switch v-model="inAdmin"></el-switch>
						<el-tooltip class="item" effect="dark" content="提示:默认为员工层" placement="top-start"
						            style="font-size: 18px;height: 20px;vertical-align: sub;margin-left: 15px;">
							<i class="el-icon-warning-outline"></i>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="是否区分占比:">
						<el-switch v-model="type"></el-switch>
						<el-tooltip class="item" effect="dark"
						            content="提示:占比顺序与审核人员逐一对应,单位百分比,默认每个审核员计算平均分占比为100%"
						            placement="top-start"
						            style="font-size: 18px;height: 20px;vertical-align: sub;margin-left: 15px;">
							<i class="el-icon-warning-outline"></i>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="审核占比(%):" v-if="type">
						<el-input v-model="it.ratio" v-for="(it,index) in examiner" :key="index"
						          style="margin-right: 10px;width: 80px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="save">保存</el-button>
						<el-button @click="diaglo=false">取消</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<!-- 职位管理 -->
		<div class="demo-alignment">
			<el-dialog title="职位管理" :visible.sync="jobdiaglo" width="60%" center :close-on-click-modal="false"
			           @close="job">
				<template>
					<div class="TestWord">
						<el-button @click="addLine">添加职位</el-button>
						<!-- <el-button @click="save">保存</el-button> -->
						<el-table
							:data="joblist"
							style="width: 100%">
							<el-table-column prop="name" label="职位名称" align="center">
								<template slot-scope="scope">
									<el-input v-model="scope.row.name" placeholder="职位名称"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="remarks" label="备注" align="center">
								<template slot-scope="scope">
									<el-input v-model="scope.row.remarks" placeholder="备注"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="bookbuytime" label="操作" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="success" icon="el-icon-edit-outline"
									           @click="handlesave(scope.$index, scope.row)">
										{{ scope.row.id ? "修改" : "保存" }}
									</el-button>
									<el-button size="mini" type="danger" icon="el-icon-delete"
									           @click="handleDelete(scope.$index, scope.row)">删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>

				</template>
			</el-dialog>
		</div>
		<!--用户信息添加与编辑-->
		<div class="demo-alignment">
			<el-dialog title="用户信息" :visible.sync="userdiaglo" width="50%" :close-on-click-modal="false">
				<el-form label-width="120px">
					<el-form-item label="所属部门:" style="80%">
						<el-cascader v-model="user.deptIds" :options="deptconfig" :props='props'
						             style="width:360px"></el-cascader>
					</el-form-item>
					<el-form-item label="职位名称:">
						<el-select v-model="user.positionId" placeholder="请选择" style="360px">
							<el-option :label="j.name" :value="j.id" v-for="(j,i) in joblist" :key="i"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="姓名:">
						<el-input v-model="user.name" placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="性别:">
						<el-select v-model="user.sex" placeholder="请选择" style="360px">
							<el-option label="未知" :value="0"></el-option>
							<el-option label="男" :value="1"></el-option>
							<el-option label="女" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号:">
						<el-input v-model="user.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱:">
						<el-input v-model="user.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
          <el-form-item label="展示评分人:">
            <el-switch
                v-model="viewPingfenFlag">
            </el-switch>
          </el-form-item>
					<el-form-item>
						<el-button type="primary" @click="saveUser">保存</el-button>
						<el-button @click="userdiaglo=false">取消</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Auditor from '@/components/Auditor'
import draggable from "vuedraggable";

export default {
	data() {
		return {
			data: [],
			userid: '',
			delid: '',  //删除的id
			member: {deptId: '', email: '', name: '', nickName: '', pageNum: 1, phone: ''},  //查询人员列表条件
			total: 0,  //总条数
			users: [],   //人员列表
			diaglo: false,
			userdiaglo: false,  //用户信息弹窗
			user: {id: '', deptId: '', deptIds: [], email: '', name: '', phone: '', positionId: '', sex: ''},  //用户信息体
			jobdiaglo: false,
			joblist: [],    //职位列表
			deptconfig: [],    //部门列表
			deptid: [],          //选择的部门
			standardconfig: [], //标准列表
			standardid: '',     //选择的标准
			positionName: '',   //选择的职位
			examineper: [],    //审核占比
			examiner: [],   //审核员
			include: "1",    //包含自评分，默认包含
			type: false,   //是否区分占比
			inAdmin: false, //是否管理层
      viewPingfenFlag: true,
			settings: { // 弹窗配置
				maxScrollbarLength: 60,
				wheelSpeed: .60,
			},
			innerVisible: false,
			props: {
				value: 'id',
				label: 'name'
			},
		}
	},
	components: {
		VuePerfectScrollbar,
		Auditor,
		draggable,
	},
	mounted() {
		this.job();
		this.getconfig();
		this.gettree();
		this.getmemberlist();
	},
	watch: {
		'member.pageNum': 'getmemberlist'
	},
	methods: {
		goauditor() {
			let auditorarr = this.examiner.map((item) => {
				let name = item.reviewerNames;
				let id = item.reviewerId;
				return {id: id, name: name};
			})
			localStorage.setItem("auditorarr", JSON.stringify(auditorarr));
			this.innerVisible = true
		},
		job() {
			const that = this;
			this.$api.getjoblist({}).then(function (response) {
				if (response.code == 0) {
					that.joblist = response.data;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		addLine() { //添加行数
			var newValue = {
				name: '',
				remarks: ''
			};
			//添加新的行数
			this.joblist.push(newValue);
		},
		handleDelete(index, row) { //删除行数
			console.log(row);
			const that = this;
			this.$api.jobdel({id: row.id}).then(function (response) {
				if (response.code == 0) {
					that.joblist.splice(index, 1);
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		handlesave(index, row) { //保存行数，也有可能是修改
			const that = this;
			console.log(row);
			if (row.id) {
				this.$api.jobedit(row).then(function (response) {
					if (response.code == 0) {
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			} else {
				this.$api.jobadd(row).then(function (response) {
					if (response.code == 0) {
						that.job();
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			}
		},
		handleClose(index) {  //分配审核员之删除
			this.examiner.splice(index, 1);
		},
		save() {
			console.log("保存");
			const that = this;
			var reviewid = this.examiner.map(it => {
				return it.reviewerId;
			})
			var obj = {
				inAdmin: this.inAdmin,
        viewPingfenFlag: this.viewPingfenFlag,
				inIncludeOwn: this.include == "1" ? true : false,
				statisticsType: this.type ? "2" : "1",
				id: this.userid,
				deptId: this.deptid[this.deptid.length - 1],
				templateId: this.standardid,
				position: this.positionName,
				reviewerId: reviewid,
				reviewer: this.examiner
			}
			this.$api.distribution(obj, {'content-type': 'application/json'}).then(function (response) {
				if (response.code == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
					that.diaglo = false;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getconfig() {	//获取所有配置，不分先后
			const that = this;
			this.$api.Configlistall({}).then(function (response) {
				if (response.code == 0) {
					that.standardconfig = response.data;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		submitmember(val) {  //分配审核员之选中
			console.log("当前选择的审核员：", val);
			this.examiner = [];
			val.forEach(item => {
				this.examiner.push({reviewerId: item.id, reviewerNames: item.name});
			})
		},
		closediaglo() {
			console.log("内部二级弹窗关闭");
			this.innerVisible = false;
		},
		userinfo(u) {
			console.log(1113333, u);
			if (u.id) {
				var that = this;
				this.user.id = u.id;
				this.user.deptId = u.deptId;
				this.user.email = u.email;
				this.user.phone = u.phone;
				this.user.name = u.name;
				this.user.positionId = u.positionId;
				this.user.sex = u.sex;
				this.$api.getdistribution({userId: u.id}).then(function (response) {
					if (response.code == 0) {
						that.user.deptIds = response.data.deptIds;
						that.userdiaglo = true;
            that.viewPingfenFlag = response.data.viewPingfenFlag;
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})

			} else {
				this.user = this.$options.data().user;
				this.userdiaglo = true;
			}
		},
		saveUser() {		//新增用户或者编辑人员
			console.log("用户信息：", this.user);
			var that = this;
			if (this.user.id) {  //编辑
				this.user.deptId = this.user.deptIds[this.user.deptIds.length - 1];
				this.user.deptIds = this.user.deptIds.toString();
        that.user.viewPingfenFlag = this.viewPingfenFlag;
				this.$api.userEdit(that.user).then(function (response) {
					if (response.code == 0) {
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
						that.userdiaglo = false;
						that.getmemberlist();
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			} else {  //添加
				this.user.deptId = this.user.deptIds[this.user.deptIds.length - 1];
				this.user.deptIds = this.user.deptIds.toString();
				this.$api.userSave(that.user).then(function (response) {
					if (response.code == 0) {
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
						that.userdiaglo = false;
						that.getmemberlist();
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			}
		},
		del(tr) {	//删除人员
			var that = this;
			this.$api.userdel({id: tr.id}).then(function (response) {
				if (response.code == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
					that.getmemberlist();
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		edit(user) {		//人员信息编辑
			var that = this;
			this.userid = user.id;
			this.$api.getdistribution({userId: user.id}).then(function (response) {
				if (response.code == 0) {
					that.diaglo = true;
					console.log(111, response);
          console.log("222222333333333333", response.data.viewPingfenFlag);

          that.deptid = response.data.deptIds;
					that.standardid = response.data.templateId;
					that.positionName = response.data.position;
					that.examiner = response.data.reviewer;
					that.inAdmin = response.data.inAdmin;
          console.log("222222333333333333", response.data.viewPingfenFlag);
          that.viewPingfenFlag = response.data.viewPingfenFlag;
					that.type = response.data.statisticsType == "1" || response.data.statisticsType == null ? false : true;
					that.include = response.data.inIncludeOwn || response.data.inIncludeOwn == null ? "1" : "2";
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		handleNodeClick(data) {    //选择部门
			console.log("当前部门", data);
			this.member.deptId = data.id;
			this.member.pageNum = 1;
			this.getmemberlist();
		},
		editNodeClick(even, data) {
			console.log("当前修改部门", data);
			const that = this;
			var s = `<div class="adddept"><input  id="name" value="${data.name}" placeholder="请输入组织名称"><select id="type"><option  value="">暂无</option><option  value="1">管理</option><option  value="2">门店</option></select></div>`;
			this.$alert(s, '修改部门',
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
				let name = document.getElementById('name').value;
				let type = document.getElementById('type').value;
				console.log("输入", name, type);
				that.$api.deptedit({
					id: data.id,
					name: name,
					type: type,
					parentId: data.parentId
				}).then(function (response) {
					if (response.code == 0) {
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
						that.gettree();
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			}).catch((err) => {
				console.log("取消输入", err);
			});
		},
		getmemberlist() {	//获取员工列表
			const that = this;
			this.$api.memberlist(that.member).then(function (response) {
				if (response.code == 0) {
					console.log("人员列表", response.data);
					that.users = response.data.data;
					that.total = response.data.pages;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		gettree() {   //获取组织架构列表
			const that = this;
			this.$api.getmember({}).then(function (response) {
				console.log("组织架构：", response);
				if (response.code == 0) {
					that.data = JSON.parse(JSON.stringify(response.data));
					that.deptconfig = that.removeEmptyChildren(response.data);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		removeEmptyChildren(node) {   //杀生
			var that = this;
			node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
			})
			return node;
		},
		append(data) {    //增加节点
			const that = this;
			this.$alert('<div class="adddept"><input  id="name" placeholder="请输入组织名称"><select  id="type"><option  value="">暂无</option><option  value="1">管理</option><option  value="2">门店</option></select></div>', '新增部门',
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
				let name = document.getElementById('name').value;
				let type = document.getElementById('type').value;
				console.log("输入", name, type);
				that.$api.deptsave({name: name, type: type, parentId: data.id}).then(function (response) {
					if (response.code == 0) {
						that.$vs.notify({
							title: "提示",
							color: 'success',
							text: response.message,
							position: 'top-center'
						});
						that.gettree();
					} else {
						that.$vs.notify({
							title: "提示",
							color: 'warning',
							text: response.message,
							position: 'top-center'
						});
					}
				})
			}).catch((err) => {
				console.log("取消输入", err);
			});

		},
		openConfirm(data) {
			this.delid = data.id;
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `警告`,
				acceptText: '确定',
				cancelText: '取消',
				text: '我的天哪！你知道你在干什么吗？are you sure??',
				accept: this.remove
			})
		},
		remove() {  ////删除节点
			var that = this;
			that.$api.deptdel({id: that.delid}).then(function (response) {
				if (response.code == 0) {
					that.$vs.notify({
						title: "提示",
						color: 'success',
						text: response.message,
						position: 'top-center'
					});
					that.gettree();
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		renderContent(h, {node, data, store}) {
			return (
				<span class="custom-tree-node">
				<span>{node.label}</span>
				<span>
				  <el-button class="mr-4" size="mini" type="text" on-click={() => this.append(data)}>添加</el-button>
				  <el-button slot="reference" size="mini" type="text"
				             on-click={() => this.openConfirm(data)}>删除</el-button>
				</span>
			  </span>);
		}
	}
};
</script>
<style>
.organiza .vs-con-table {
	width: 100%;
	height: 100%;
	overflow: auto;
	min-width: 40vw;
}

.custom-tree-container {
	width: 100%;
	width: 100%;
	min-height: 80vh;
	background: #fff;
	border-radius: 1rem;
	padding: 1rem;
}

.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-right: 8px;
}

.organiza .TestWord .el-table {
	height: 450px !important;
	overflow: auto;
}

.adddept {
	display: flex;
	flex-direction: column;
	height: 100px;
	justify-content: space-between;
}

.adddept input, .adddept select {
	outline: none;
	border: 1px solid rgba(0, 0, 0, 0.2);
	padding: .8rem 1rem 0.8rem 1rem;
	font-size: 1rem;
}
</style>
